import script from "./SixthScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./SixthScreen.vue?vue&type=script&setup=true&lang=js"

import "./SixthScreen.vue?vue&type=style&index=0&id=78621b0d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78621b0d"]])

export default __exports__